import React from "react";
import UserDeatilType from "Mapa/types/UserDetailType";

export const UserModal = ({
  setOpenModal,
  users,
  handleOnChangeUserIndex,
  selectedUser,
  nameStore,
}: {
  setOpenModal: any;
  users: Array<any>;
  handleOnChangeUserIndex: (index: number) => void;
  selectedUser: UserDeatilType;
  nameStore: String;
}) => {
  const handleClick = () => {
    setOpenModal(false);
  };

  return (
    <div className="h-full w-full ">
      <div className="w-[600px] h-[350px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 absolute bg-[rgba(255,255,255,.8)] rounded-[15px]">
        <div className="flex flex-col">
          <div className="flex justify-between h-[25px] p-1">
            <p className="text-2xl">{nameStore}</p>
            <div
              className="cursor-pointer flex items-center justify-center"
              onClick={handleClick}
            >
              <p className="text-4xl">x</p>
            </div>
          </div>
          <div className="flex w-full justify-center p-2 mt-4">
            <div className="flex flex-col w-[40%] p-2 border-r-2 border-gray-400 overflow-y-auto h-[290px] no-scrollbar">
              {users &&
                users.map((user: any, index: number) => {
                  const backgroud =
                    user.type.indexOf("SUPERVISOR") > -1
                      ? `bg-red-600`
                      : `bg-yellow-400`;
                      const arrow = user.id === selectedUser?.id ? "flecha_derecha" : "flecha_izquierda"

                  const type = user.type.indexOf("SUPERVISOR") > -1 ? `S` : `D`;

                  return (
                    <div className="flex m-1 justify-between items-center">
                      <div className="flex">
                        <div
                          className={`${backgroud} w-[20px] h-[20px] rounded-full flex items-center justify-center`}
                        >
                          <p className="text-sm font-bold text-white text-[11px]">
                            {type}
                          </p>
                        </div>
                        <p className="text-[11px] ml-1 ">{user.name}</p>
                      </div>
                      <img
                        className="cursor-pointer"
                        src={`${process.env.PUBLIC_URL}/assets/Icons/${arrow}.svg`}
                        onClick={() => {
                          handleOnChangeUserIndex &&
                            handleOnChangeUserIndex(index);
                        }}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="p-2 w-[60%]">
              <div className="flex flex-col">
                <div className="mb-2">
                  <p className="text-[20px]">{selectedUser?.name}</p>
                </div>
                <div className="flex justify-center items-center space-x-4">
                  <div className="flex flex-col">
                    <div className="flex space-x-2">
                      <p className="font-bold text-[18px]">
                        {selectedUser.assistance?.hour && "Entrada"}
                      </p>
                      <p className="text-[18px]">
                        {selectedUser?.assistance?.hour}
                      </p>
                    </div>
                    <div className="flex justify-center items-center items-center py-3">
                      {selectedUser.assistance?.url && (
                        <img
                          className="w-[80px] h-[100px] object-cover"
                          src={selectedUser.assistance?.url}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="flex space-x-2">
                      <p className="font-bold text-[18px]">
                        {selectedUser.closeAssistance?.hour && "Salida"}
                      </p>
                      <p className="text-[18px]">
                        {selectedUser.closeAssistance?.hour}
                      </p>
                    </div>
                    <div className="flex justify-center items-center py-3">
                      {selectedUser.closeAssistance?.url && (
                        <img
                          className="w-[80px] h-[100px] object-cover"
                          src={selectedUser.closeAssistance?.url}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
